import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "x-circle-w58z5",
  "use": "x-circle-w58z5-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"x-circle-w58z5\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M15 9l-6 6M9 9l6 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol